import { EventType } from "./constants/event-type-constants";
import { DataLayerConstants } from "./constants/data-layer-constants";
export class DataLayer {
    static pushEventToDataLayer(config, isClick = false) {
        var _a, _b;
        window[DataLayerConstants.dataLayer] = (_a = window[DataLayerConstants.dataLayer]) !== null && _a !== void 0 ? _a : [];
        const { ctaCategory: gtmCategory, cta: gtmLabel } = config;
        (_b = window[DataLayerConstants.dataLayer]) === null || _b === void 0 ? void 0 : _b.push({
            gtmAction: isClick ? EventType.CLICK : EventType.DISPLAY,
            gtmLabel,
            gtmCategory,
            event: DataLayerConstants.paywallEventName
        });
    }
    static sendDMEvent(ctaCategory, cta) {
        var _a;
        const customDataLayer = (_a = window[DataLayerConstants.customDataLayer]) !== null && _a !== void 0 ? _a : {};
        if (typeof customDataLayer.zajawkaDMEvent !== "function")
            return;
        customDataLayer.zajawkaDMEvent({
            category: ctaCategory,
            action: DataLayerConstants.displayAttribute,
            message: cta
        });
    }
}
